<template>
    <div>
        <h2>
            {{ title }}
        </h2>
        <div
            class="notice"
            v-html="content"
        ></div>
        <div
            v-if="!isLoading"
            class="btn__group"
        >
            <CustomButton
                v-for="action in actions"
                :key="action.id"
                :isLoading="isLoading"
                @click="onAction(action.id)"
                class="btn btn__primary"
            >
                {{ $t(action.name) | capitalize }}
            </CustomButton>
        </div>
        <div
            v-if="isLoading"
        >
            <CustomButton
                :isLoading="isLoading"
                class="btn__primary btn--w-144"
            />
        </div>
    </div>
</template>


<script>
    import { mapActions, mapGetters } from 'vuex';
    import { errorGuard } from '@app/utils';

    export default {
        name: 'MessageModal',
        data() {
            return {
                isLoading: false
            };
        },
        computed: {
            ...mapGetters('ui/modal', [
                'modalData'
            ]),
            title() {
                return this.modalData.title;
            },
            content() {
                return this.modalData.content;
            },
            actions() {
                return this.modalData.actions;
            }
        },
        methods: {
            ...mapActions('ui/user/messages', [
                'respondAndShowNextBonusMessage',
            ]),
            async onAction(actionId) {
                this.isLoading = true;
                /*
                    Since this modal is closed when showing the next one (for the error
                    or the next message), there is no need to close it explicitly.
                */
                await errorGuard({
                    action: () => this.respondAndShowNextBonusMessage(actionId)
                });
                this.isLoading = false;
            },
        }
    };
</script>


// WEBPACK FOOTER //
// src/app/modals/modals/messages/MessageModal.vue